import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Pin = function Pin(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13.8 0.02 62.42 89.98",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Map Pin Icon"
    }), /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M72.7 16.8c-5.9-11.2-18-18-31-16.6C35.6.8 30.1 3.1 25.4 7c-7 5.7-10.8 13-11.5 22-.4 5.3.4 10.5 2.8 15.3 1.5 3 3.2 5.8 4.9 8.6 6.2 9.9 12.4 19.8 18.6 29.6 1.6 2.5 3.2 4.9 4.8 7.5.4-.6.7-1.1 1-1.5 8.4-13.4 16.7-26.7 25.1-40.1 2.8-4.4 4.5-9.1 5-14.3.5-6.1-.6-11.9-3.4-17.3zM44.9 48.3c-9.3 0-17-7.7-17-17.1 0-9.4 7.7-17.1 17.1-17.1 9.4 0 17.1 7.7 17.1 17.1 0 9.5-7.7 17.1-17.2 17.1z"
    })]
  });
};

export default Pin;